import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import type { CustomRouteComponentProps } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import CLIENT from 'af-constants/routes/client';

import { Button, SearchInput } from '@acceligentllc/storybook';

interface OwnProps {
	showSmallButtons: boolean;
	showToolbarHeaders: boolean;
	incrementHighlightedNodeIndex: () => void;
	decrementHighlightedNodeIndex: () => void;
	isAllowedToCreate: boolean;
	filter: string;
	currentResult: number;
	totalResults: number;
	collapseAll: () => void;
	expandAll: () => void;
	onFilter: (query: string) => void;
	isAnyExpanded: boolean;
	companyName: string;
	orgAlias: string;
}

type Props = OwnProps & CustomRouteComponentProps<void>;

const TreeHeader: React.FC<Props> = (props) => {
	const {
		collapseAll,
		companyName,
		currentResult,
		decrementHighlightedNodeIndex,
		expandAll,
		filter,
		history,
		incrementHighlightedNodeIndex,
		isAllowedToCreate,
		isAnyExpanded,
		onFilter,
		orgAlias,
		showSmallButtons,
		showToolbarHeaders,
		totalResults,
	} = props;

	const onFilterKeyDown = React.useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			if (event.shiftKey) {
				decrementHighlightedNodeIndex();
			} else {
				incrementHighlightedNodeIndex();
			}
		}
	}, [decrementHighlightedNodeIndex, incrementHighlightedNodeIndex]);

	const goToCreate = React.useCallback(() => {
		history.push(CLIENT.COMPANY.RESOURCES.EQUIPMENT_COST.CREATE(orgAlias, companyName));
	}, [companyName, history, orgAlias]);

	const goToCSVImport = React.useCallback(() => {
		history.push(CLIENT.COMPANY.RESOURCES.EQUIPMENT_COST.BULK_UPLOAD(orgAlias, companyName));
	}, [companyName, history, orgAlias]);

	const renderTableHeaders = () => (
		<Row className="tree-table__header-titles">
			<Col md={1}>
				{isAnyExpanded
					? <span className="tree-table__expander icon-collapse" onClick={collapseAll} />
					: <span className="tree-table__expander icon-expand" onClick={expandAll} />
				}
			</Col>
			<Col md={7}>
				Name
			</Col>
			<Col md={5}>
				{showSmallButtons ? 'Skills' : 'Needed Skills'}
			</Col>
			<Col md={2}>
				{showSmallButtons ? '$/Day' : 'Daily Cost'}
			</Col>
			<Col md={2}>
				{showSmallButtons ? '$/Week' : 'Weekly Cost'}
			</Col>
			<Col md={2}>
				{showSmallButtons ? '$/Month' : 'Monthly Cost'}
			</Col>
			<Col md={2}>
				Mob Charge
			</Col>
			<Col md={2}>
				{showSmallButtons ? 'Op hr Charge' : 'Op Hour Charge'}
			</Col>
			<Col md={2}>
				{showSmallButtons ? 'Fuel' : 'Fuel Cost'}
			</Col>
			<Col className="pull-right" md={4}>
				Updated
			</Col>
			<Col md={1} />
		</Row>
	);

	const idAndClassName = 'tree-table__header';

	return (
		<div
			className={idAndClassName}
			id={idAndClassName}
		>
			<div className="tree-table__header-container">
				<div className="tree-table__header-left">
					<div className="tree-table__match-filter">
						<SearchInput
							currentResult={currentResult}
							hasClear={true}
							name="filter"
							onChange={onFilter}
							onKeyDown={onFilterKeyDown}
							onNext={incrementHighlightedNodeIndex}
							onPrevious={decrementHighlightedNodeIndex}
							placeholder="Search"
							totalResults={totalResults}
							value={filter}
						/>
					</div>
				</div>
				<div className="tree-table__header-right">
					{
						isAllowedToCreate &&
						<>
							<Button
								icon="ActionImport"
								label="CSV Import"
								onClick={goToCSVImport}
								style="link"
							/>
							<Button
								label="New Equipment Cost"
								onClick={goToCreate}
								style="primary"
							/>
						</>
					}
				</div>
			</div>
			{showToolbarHeaders && renderTableHeaders()}
		</div >
	);
};

export default React.memo(withRouter(TreeHeader));
